import { FC } from 'react';

type HoleInOneClaimDetailsListProps = {
  claimWitnesses: string[];
  noWitnessesText: string;
};

const HoleInOneClaimDetailsList: FC<HoleInOneClaimDetailsListProps> = ({
  claimWitnesses,
  noWitnessesText,
}) => {
  if (!claimWitnesses.length) {
    return <div className="text-gray-500 italic my-4">{noWitnessesText}</div>;
  }

  return (
    <ul className="mt-4 mb-2">
      {claimWitnesses.map((claimWitness) => (
        <li key={claimWitness}>
          <div className="mb-2 p-4 border rounded-xl shadow-sm bg-primary-100">
            <p className="text-white">{claimWitness}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default HoleInOneClaimDetailsList;
